import React, { useState } from 'react';
import * as styles from './horizontalControls.module.scss';
import ArrowBack from '../../../../static/arrowBack.svg';
import ArrowForward from '../../../../static/arrowForward.svg';
import Swiper from 'swiper/types/swiper-class';

interface IHorizontalControlsProps {
  swiper: Swiper | undefined;
}

export const HorizontalControls = ({ swiper }: IHorizontalControlsProps) => {
  const [_, setActiveIndex] = useState(0);

  if (swiper && 'activeIndex' in swiper) {
    swiper?.on('slideChange', () => setActiveIndex(swiper.activeIndex));
  }

  return (
    <div className={styles.controls}>
      <button
        aria-label="prev"
        type="button"
        onClick={() => swiper?.slidePrev()}
        className={`${styles.button} ${styles.left} ${swiper?.isBeginning ? styles.inactive : ''}`}
      >
        <ArrowBack />
      </button>
      <button
        aria-label="next"
        type="button"
        onClick={() => swiper?.slideNext()}
        className={`${styles.button} ${styles.right} ${swiper?.isEnd ? styles.inactive : ''}`}
      >
        <ArrowForward />
      </button>
    </div>
  );
};
